<template>
	<div class="paginator clearfix" aria-label="Question Selector" id="question-nav" tabindex="-1">
		<h2 class="paginator-title">Questions:</h2> 
		<div v-if="testQuestions.length" class="flex-container-wrap">
			<div v-for="( questionId, index ) in testQuestions" 
					:key="index" 
					:class="`${ getClassNames( questionId ) } ${ isFlagged( questionId ) ? 'flag' : '' }`"
					role="button" 
					tabindex="0"
					:aria-label="'Question' + ( index + 1 ) "
					@click="setActiveQuestionAction( questionId )"
					@keyup.enter="setActiveQuestionAction( questionId )"
					@keyup.space="setActiveQuestionAction( questionId )" >
				<font-awesome-icon v-if="isFlagged( questionId )" icon="flag" aria-hidden="true"></font-awesome-icon>
				<font-awesome-icon v-else-if="isGraded( questionId ) && !isCorrect( questionId )" icon="times" aria-hidden="true">
				</font-awesome-icon>
				<span v-else>{{ index + 1 }}</span>
			</div>
		</div>
		<div class="text-center submit">
			<button role="button"
							tabindex="0"
							arial-label="Submit Test"
							v-if="!reviewMode"
							:class="[ 'btn btn-light-blue', { disabled: !activeQuestionId } ]"
							@click="jumpToSubmit()">
				<font-awesome-icon icon="arrow-alt-circle-up"></font-awesome-icon> 
				{{ $t('MAIN_CONTENT.testButtons.takeTester_submitTest') }}
			</button>
		</div>
	</div>
</template>

<script>
	import { mapState,mapMutations, mapActions } from "vuex";

	export default {
		computed: {
				...mapState( {
						testQuestions: state =>{
								return state.testTaker.testPreview.QUESTIONS.filter( q=>{
										return !q.TEST_QUESTION_PARENT_RID; 
								} ).map( q =>{
										return q.TEST_QUESTION_RID; 
								} );
						},
						studentAnswers: state =>{
								return state.testTaker.testPreview ? state.testTaker.testPreview.STUDENT_ATTEMPT.ANSWERS : {};
						},
						flaggedQuestions: state =>{
								return state.testTaker.flaggedQuestions;
						},
						activeQuestionId: state =>{
								return state.testTaker.activeQuestion ? state.testTaker.activeQuestion.TEST_QUESTION_RID : "";
						},
						reviewMode: state =>{
								return state.testTaker.reviewMode;
						}
				} )
		},
		methods: {
				...mapMutations( [ "updateState"] ),
				...mapActions(['setActiveQuestionAction']),
				isFlagged ( questionId ){
						return this.flaggedQuestions.indexOf( questionId ) > -1;
				},
				isAnswered ( questionId ){
						return Object.prototype.hasOwnProperty.call( this.studentAnswers, questionId );
				},
				isCorrect ( questionId ){
						return this.studentAnswers[ questionId ].filter( ans =>{
								return ans.ANSWER_CORRECT_FLG;
						} ).length > 0;
				},
				isGraded ( questionId ){
						return this.isAnswered( questionId ) 
										&& this.studentAnswers[ questionId ].filter( ans =>{
												return ans.QUESTION_GRADED_STATUS && ans.QUESTION_GRADED_STATUS !== 'P'; 
										} ).length > 0;
				},
				jumpToSubmit (){
						this.updateState( { key: "activeQuestion", value: null } );
				},
				// assemble the proper classnames to display if a question was: answered | marked correct | marked incorrect 
				getClassNames ( questionId ){
						let clsName = "page";
						if( this.isAnswered( questionId ) ){
								clsName += " answered";
						}
						if( this.isGraded( questionId ) ){
								if( this.isCorrect( questionId ) ){
										clsName += " correct";
								} else {
										clsName += " incorrect";
								}
						}
						if( questionId === this.activeQuestionId ){
							clsName += " selected";
						}
						return clsName;
				}
		}
	};
</script>

<style scoped>
	.flex-container-wrap {
		justify-content:left !important;
	}
</style>
